import { requestApi } from '../util/network'
// 投诉列表
export const getComplaintList =
    (params) =>
      requestApi(
        '/member_o2o_complaint/index',
        'POST',
        {
          page: params.page,
          per_page: params.per_page
        },
        'member'
      )
// 新增投诉
export const addComplaint =
(order_id, order_type, content) =>
  requestApi(
    '/member_o2o_complaint/add',
    'POST',
    {
      order_id: order_id,
      order_type: order_type,
      content: content
    },
    'member'
  )
// 删除投诉
export const delComplaint =
    (o2o_complaint_id) =>
      requestApi(
        '/member_o2o_complaint/del',
        'POST',
        {
            o2o_complaint_id: o2o_complaint_id
        },
        'member'
      )
